/**
 * Created by Ning Jiang on 7/5/2019.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TimelineLite} from "gsap";
import {PixiesVsPiratesSoundConfig} from "../../PixiesVsPiratesSoundConfig";
import {PixiesVsPiratesParsedGameData} from "../../server/parseddata/PixiesVsPiratesParsedGameData";
import {BattleCollectView} from "./BattleCollectView";
import {BattleEvent} from "./BattleEvent";

export class BattleCollectController extends ReelStopPresentationController {

    private readonly _pixiePosition:[number, number] = [387, 40];
    private readonly _piratePosition:[number, number] = [893, 40];
    private readonly _collectDelay:number = 0.2;
    private readonly _playDefeatDelay:number = 0.5;

    private _view:BattleCollectView;
    private _battleData:PixiesVsPiratesParsedGameData | null;
    private _reelStopStates:boolean[];
    private _battleCollectionSoundPlayed:boolean;

    constructor(index:number) {
        super(index, "BattleCollect");
        this._view = new BattleCollectView();
        this._battleCollectionSoundPlayed = false;
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, SpinEvent.START, (event:GamepadEvent) => this.onSpinStart());
    }

    private onSpinStart():void {
        this._reelStopStates = ArrayHelper.initArrayWithValues(6, index => false);
    }

    protected dispatchCompleteEvent(reelId:number):void {
        if(this._battleData!.mode === GameMode.FREESPIN) {
            if(this.isLastReel(reelId)) {
                EventHandler.dispatchEvent(new GameEvent(BattleEvent.CHECK_COLLECT, this._battleData!.pixieFSCount, this._battleData!.pirateFSCount));
                EventHandler.dispatchEvent(new GameEvent(BattleEvent.PLAY_DEFEAT, this._battleData!.pixieFSCount > this._battleData!.pirateFSCount));
                this._battleCollectionSoundPlayed = false;
            }
        }
        this._reelStopStates[reelId] = true;
        super.dispatchCompleteEvent(reelId);
    }

    private isLastReel(reelId:number):boolean {
        for(let i:number = 0; i < 6; i++) {
            if(i === reelId) {
                continue;
            }

            // there is not stopped reel
            if(!this._reelStopStates[i]) {
                return false;
            }
        }
        return true;
    }

    protected parseFeatureGameData(data:PixiesVsPiratesParsedGameData):void {
        this._battleData = data;
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if(this._battleData!.mode != GameMode.FREESPIN) {
            this.dispatchCompleteEvent(data.reelId);
            return;
        }

        const timeline:TimelineLite = new TimelineLite({paused : true});
        let delay:number = 0;
        this._battleData!.pixieCollectPositions[data.reelId].forEach((shouldCollect:boolean, symId:number) => {
            if(shouldCollect) {
                // Logger.logDev(`BattleCollectController.onReelSpinStopped(): reelId = ${data.reelId}, pixie + 1`);
                timeline.add(this._view.playCollector(1, Helper.getSymbolPositions(data.reelId, symId, true), this._pixiePosition, () => EventHandler.dispatchEvent(new GameEvent(BattleEvent.COLLECT_PIXIE))), delay);
                delay += this._collectDelay;
            }
        });

        if(delay > 0) {
            delay += this._collectDelay;
        }

        this._battleData!.pirateCollectPositions[data.reelId].forEach((shouldCollect:boolean, symId:number) => {
            if(shouldCollect) {
                // Logger.logDev(`BattleCollectController.onReelSpinStopped(): reelId = ${data.reelId}, pirate + 1`);
                timeline.add(this._view.playCollector(2, Helper.getSymbolPositions(data.reelId, symId, true), this._piratePosition, () => EventHandler.dispatchEvent(new GameEvent(BattleEvent.COLLECT_PIRATE, this._battleData!.pirateFSCount))), delay);
                delay += this._collectDelay;
            }
        });
        if(!this._battleCollectionSoundPlayed && (this._battleData!.pirateCollectPositions[data.reelId].filter((a) => { return a === true}).length > 0 || this._battleData!.pixieCollectPositions[data.reelId].filter((a) => { return a === true}).length > 0)) {
            timeline.add(() => SlotGame.sound.playEffect(PixiesVsPiratesSoundConfig.FS_COLLECT), 0);
            this._battleCollectionSoundPlayed = true;
        }
        timeline.add(() => this.dispatchCompleteEvent(data.reelId));
        timeline.play();
    }
}